import firebase from "firebase/app";
export const initFirebase = () => {
	var firebaseConfig = {
		apiKey: "AIzaSyD4-r0x2Dt7dlWQpYWTEefF-rre2JlmKFo",
		authDomain: "the-brain-stormer.firebaseapp.com",
		databaseURL: "https://the-brain-stormer-default-rtdb.firebaseio.com",
		projectId: "the-brain-stormer",
		storageBucket: "the-brain-stormer.appspot.com",
		messagingSenderId: "3711002148",
		appId: "1:3711002148:web:7bf9f80b07ae85e76a9ab1",
	};
	firebase.default.initializeApp(firebaseConfig);
};
